import { Tag } from '../../../store/Tags';
import { TagItem } from './TagItem';

export interface TagsDetailsProps {
  entityTags: Tag[];
  isGrid?: boolean;
}

export const TagsDetails = ({ entityTags, isGrid }: TagsDetailsProps) => {
  return (
    <div className={`flex flex-row gap-2 ${isGrid ? 'h-6 overflow-x-clip' : 'flex-wrap '}`}>
      {entityTags.length > 0 &&
        entityTags.map((tag) => (
          <TagItem
            key={tag.id}
            tag={tag}
          />
        ))}
    </div>
  );
};
